export default "__VITE_ASSET__BqN7w57N__"